export const toursData = [
  {
    id: "kerala-experience",
    title: "Enchanting Kerala Backwaters",
    category: "Domestic",
    price: 24999,
    originalPrice: 29999,
    duration: "6 Days / 5 Nights",
    rating: 4.8,
    reviewsCount: 124,
    image: "https://images.unsplash.com/photo-1593693397690-362cb9666fc2?auto=format&fit=crop&w=800&q=80",
    tag: "Best Seller",
    shortDescription: "Experience the tranquil backwaters, lush tea gardens of Munnar, and pristine beaches of Kovalam.",
    description: "Welcome to Kerala, fondly known as 'God's Own Country'. This meticulously crafted tour takes you through the verdant tea plantations of Munnar, the wildlife sanctuary of Thekkady, the serene backwaters of Alleppey in a traditional houseboat, and the golden sands of Kovalam beach.",
    highlights: [
      "Stay in a luxury traditional houseboat in Alleppey",
      "Spice plantation walk and boat safari in Thekkady",
      "Tea garden tour and waterfall visits in Munnar",
      "Sunset views and cultural Kathakali dance performance"
    ],
    itinerary: [
      {
        day: 1,
        title: "Arrival in Cochin & Drive to Munnar",
        description: "Arrive at Cochin Airport/Railway Station. Meet our representative and drive to Munnar (approx. 4 hours). On the way, enjoy the beautiful Valara and Cheeyappara waterfalls. Check in to your resort and relax. Evening at leisure."
      },
      {
        day: 2,
        title: "Munnar Sightseeing",
        description: "After breakfast, embark on a full day sightseeing tour of Munnar. Visit Mattupetty Dam, Kundala Lake, Echo Point, and the Tea Museum. Take a walk through the lush tea gardens and capture stunning photos."
      },
      {
        day: 3,
        title: "Munnar to Thekkady (Periyar)",
        description: "Drive to Thekkady (approx. 3.5 hours) through winding roads lined with spice plantations. In the afternoon, enjoy a boat safari on Periyar Lake inside the wildlife sanctuary to spot wild elephants. Visit a local spice farm in the evening."
      },
      {
        day: 4,
        title: "Thekkady to Alleppey (Houseboat Cruise)",
        description: "Proceed to Alleppey (approx. 3.5 hours). Check into your private traditional Kettuvallam (houseboat). Cruise along the palm-fringed canals, observing rural village life. Enjoy traditional Kerala cuisine served freshly on board."
      },
      {
        day: 5,
        title: "Houseboat to Kovalam via Trivandrum",
        description: "Disembark after breakfast and drive to Kovalam. En route, visit the magnificent Padmanabhaswamy Temple in Trivandrum. Check in at your beach resort in Kovalam. Spend a relaxing evening by the crescent-shaped Kovalam Beach."
      },
      {
        day: 6,
        title: "Departure from Trivandrum",
        description: "After breakfast, check out from the resort. Depending on your flight/train schedule, transfer to Trivandrum Airport or Railway Station for your journey home with beautiful memories of Kerala."
      }
    ]
  },
  {
    id: "leh-ladakh-adventure",
    title: "Leh Ladakh Himalayan Odyssey",
    category: "Domestic",
    price: 34999,
    originalPrice: 42999,
    duration: "7 Days / 6 Nights",
    rating: 4.9,
    reviewsCount: 88,
    image: "https://images.unsplash.com/photo-1544735716-392fe2489ffa?auto=format&fit=crop&w=800&q=80",
    tag: "Adventure",
    shortDescription: "Traverse high altitude passes, marvel at Pangong Lake, and explore historical monasteries.",
    description: "Prepare for the ultimate mountain adventure. Ladakh offers stark, breathtaking landscapes, crystal-clear blue lakes, high altitude mountain passes, and a serene Buddhist culture. This tour covers the key sights including Leh, Nubra Valley via Khardung La, and the famous Pangong Tso.",
    highlights: [
      "Drive through Khardung La, one of the world's highest motorable roads",
      "Stay in luxury tents next to the sparkling Pangong Tso Lake",
      "Double-humped Bactrian camel ride in Hunder sand dunes",
      "Explore ancient monasteries of Thiksey and Hemis"
    ],
    itinerary: [
      {
        day: 1,
        title: "Leh Airport Arrival & Acclimatization",
        description: "Arrive at Leh Airport and transfer to hotel. Due to the high altitude (11,500 ft), you must spend the day resting completely to acclimatize. In the evening, take a slow, gentle walk to Leh Market or Shanti Stupa for sunset views."
      },
      {
        day: 2,
        title: "Leh Monasteries & Hall of Fame",
        description: "Visit the historical Sangam (confluence of Indus and Zanskar rivers), Magnetic Hill, Pathar Sahib Gurudwara, and the Indian Army Hall of Fame museum. Return to Leh for overnight stay."
      },
      {
        day: 3,
        title: "Leh to Nubra Valley via Khardung La",
        description: "Drive to Nubra Valley traversing Khardung La pass at 17,582 ft. Check into your deluxe camp. In the afternoon, visit Diskit Monastery to see the giant Buddha statue, then enjoy a camel ride on the sand dunes of Hunder."
      },
      {
        day: 4,
        title: "Nubra Valley to Pangong Lake via Shyok Route",
        description: "Drive directly to Pangong Lake via the scenic Shyok river route. The lake, situated at 14,270 ft, is shared between India and China and is famous for changing colors. Check into your lakefront tents and watch the starry night."
      },
      {
        day: 5,
        title: "Pangong Lake back to Leh",
        description: "Wake up to a pristine sunrise over the lake. Drive back to Leh crossing the high Chang La pass (17,590 ft). En route, visit Thiksey Monastery, a majestic twelve-story complex resembling the Potala Palace."
      },
      {
        day: 6,
        title: "Leh Local Leisure & Exploration",
        description: "A free day to explore Leh at your own pace. You can go shopping for Tibetan handicrafts, apricots, and pashmina shawls, or visit the old Leh Palace. Dinner and overnight stay in Leh."
      },
      {
        day: 7,
        title: "Departure from Leh",
        description: "Early morning transfer to Leh Airport for your flight back home, with unforgettable views of the snow-capped Himalayan peaks from above."
      }
    ]
  },
  {
    id: "royal-rajasthan",
    title: "Royal Rajasthan Heritage Tour",
    category: "Domestic",
    price: 21999,
    originalPrice: 26999,
    duration: "6 Days / 5 Nights",
    rating: 4.7,
    reviewsCount: 156,
    image: "https://images.unsplash.com/photo-1477584322902-471a5db55dcf?auto=format&fit=crop&w=800&q=80",
    tag: "Heritage",
    shortDescription: "Step back in time to explore magnificent forts, colorful bazaars, and palaces in Jaipur and Udaipur.",
    description: "Immerse yourself in the colors, history, and royal grandeur of Rajasthan. Explore the 'Pink City' of Jaipur with its magnificent forts and palaces, and travel to the romantic 'City of Lakes', Udaipur, experiencing traditional Rajasthani hospitality and culture.",
    highlights: [
      "Elephant or Jeep ride at Amer Fort in Jaipur",
      "Boat ride on Lake Pichola with views of Lake Palace in Udaipur",
      "Visit the iconic Hawa Mahal and City Palace",
      "Traditional Rajasthani dinner show with folk dance"
    ],
    itinerary: [
      {
        day: 1,
        title: "Arrival in Jaipur",
        description: "Arrive in Jaipur and check in to your heritage style hotel. In the evening, visit Chokhi Dhani, a recreated ethnic village resort, to enjoy camel rides, folk dances, puppet shows, and a lavish authentic Rajasthani thali dinner."
      },
      {
        day: 2,
        title: "Jaipur City Palace & Forts",
        description: "Visit the grand Amer Fort in the morning. Later, photo stop at Hawa Mahal (Palace of Winds), visit the City Palace Museum, and check the ancient astronomical instruments at Jantar Mantar observatory."
      },
      {
        day: 3,
        title: "Jaipur to Jodhpur (The Blue City)",
        description: "Drive to Jodhpur (approx. 6 hours). Check into your hotel. In the afternoon, visit the colossal Mehrangarh Fort towering above the blue-washed houses, and Jaswant Thada, a royal white-marble cenotaph."
      },
      {
        day: 4,
        title: "Jodhpur to Udaipur via Ranakpur Temple",
        description: "Drive to Udaipur (approx. 5 hours). Stop on the way to visit the architectural marvel of Ranakpur Jain Temple, famous for its 1444 uniquely carved marble pillars. Arrive in Udaipur, check in, and enjoy a lakeside dinner."
      },
      {
        day: 5,
        title: "Udaipur Sightseeing",
        description: "Explore the City Palace complex, the largest in Rajasthan. Visit Jagdish Temple and the gardens of Saheliyon-ki-Bari. In the evening, enjoy a scenic boat cruise on Lake Pichola, floating past the illuminated Lake Palace."
      },
      {
        day: 6,
        title: "Departure from Udaipur",
        description: "Transfer to Udaipur Airport or Railway Station for your journey home, carrying memories of royal forts, peaceful lakes, and vibrant cultures."
      }
    ]
  },
  {
    id: "swiss-alps-paradise",
    title: "Swiss Alps & Scenic Lakes Luxury",
    category: "International",
    price: 159999,
    originalPrice: 189999,
    duration: "7 Days / 6 Nights",
    rating: 4.95,
    reviewsCount: 94,
    image: "https://images.unsplash.com/photo-1502784444187-359ac186c5bb?auto=format&fit=crop&w=800&q=80",
    tag: "Luxury",
    shortDescription: "Experience the peak of European beauty with alpine train rides, Lucerne, and Jungfraujoch.",
    description: "Embark on a dream European vacation through Switzerland. Witness snow-clad mountain peaks, pristine glacier lakes, green valleys, and charming alpine villages. This package covers Lucerne, Interlaken, and the ultimate journey to the top of Europe - Jungfraujoch.",
    highlights: [
      "Cogwheel train ride to Jungfraujoch - Top of Europe",
      "Scenic cruise on Lake Lucerne with alpine views",
      "Ride the famous GoldenPass Express panoramic train",
      "Stay in beautiful Swiss chalets in Interlaken and Lucerne"
    ],
    itinerary: [
      {
        day: 1,
        title: "Arrival in Zurich & Transfer to Lucerne",
        description: "Arrive at Zurich Airport. Activate your Swiss Travel Pass and board the train directly to the picturesque lakeside town of Lucerne (approx. 1 hour). Check into your hotel. Walk across the 14th-century Chapel Bridge."
      },
      {
        day: 2,
        title: "Mount Pilatus Golden Roundtrip",
        description: "Embark on an exciting journey: cruise on Lake Lucerne, ride the world's steepest cogwheel railway to Mt. Pilatus (7,000 ft), enjoy views of 73 alpine peaks, and descend via aerial cableways."
      },
      {
        day: 3,
        title: "Lucerne to Interlaken via GoldenPass Line",
        description: "Board the panoramic GoldenPass express train from Lucerne to Interlaken. Marvel at the dramatic waterfalls and crystal-clear lakes. Spend the afternoon shopping for Swiss watches and chocolates in Interlaken."
      },
      {
        day: 4,
        title: "Jungfraujoch Excursion - Top of Europe",
        description: "Take the train to Lauterbrunnen and ride up to Jungfraujoch, the highest railway station in Europe at 11,333 ft. Visit the Sphinx Observatory, walk inside the Ice Palace, and step out onto the eternal snow glacier."
      },
      {
        day: 5,
        title: "Interlaken to Geneva via Montreux",
        description: "Travel by train to Montreux on the shores of Lake Geneva. Visit the medieval Chillon Castle. Continue your journey to the international hub of Geneva. Check in to your hotel."
      },
      {
        day: 6,
        title: "Geneva City Tour & Lake Geneva Cruise",
        description: "Explore Geneva's top sights including the Jet d'Eau fountain (140m high), the flower clock, and the United Nations headquarters. End your day with a relaxing sunset cruise on Lake Geneva."
      },
      {
        day: 7,
        title: "Departure from Geneva or Zurich",
        description: "Transfer to Geneva or Zurich Airport via train for your return flight home, bidding farewell to the alpine heaven."
      }
    ]
  },
  {
    id: "maldives-escape",
    title: "Maldives Water Villa Resort Escape",
    category: "International",
    price: 119999,
    originalPrice: 139999,
    duration: "5 Days / 4 Nights",
    rating: 4.9,
    reviewsCount: 202,
    image: "https://images.unsplash.com/photo-1439066615861-d1af74d74000?auto=format&fit=crop&w=800&q=80",
    tag: "Honeymoon Special",
    shortDescription: "Unwind in an overwater villa, swim in turquoise waters, and enjoy a romantic sunset cruise.",
    description: "Indulge in a tropical paradise. Stay in an exquisite overwater villa suspended over a turquoise lagoon filled with vibrant marine life. This getaway is perfect for couples and leisure seekers looking for ultimate relaxation, spa treatments, and water activities.",
    highlights: [
      "4 nights in a premium Overwater Villa with direct lagoon access",
      "Speedboat transfers from Male International Airport",
      "All-inclusive buffet meals and premium beverages",
      "Complimentary snorkeling equipment and guided reef safari"
    ],
    itinerary: [
      {
        day: 1,
        title: "Male Arrival & Speedboat to Island Resort",
        description: "Arrive at Velana International Airport in Male. Meet the resort representative and board a speedboat that whisks you away to your luxury island resort. Check into your overwater villa. Unpack, unwind, and watch the ocean under your floor glass panel."
      },
      {
        day: 2,
        title: "Snorkeling Safari & Spa Treatment",
        description: "After breakfast, join a guided boat trip to the house reef to snorkel with sea turtles, stingrays, and colorful reef fish. In the afternoon, enjoy a complimentary couples' massage at the resort's overwater wellness spa."
      },
      {
        day: 3,
        title: "Water Sports & Romantic Sunset Cruise",
        description: "Try your hand at kayaking, windsurfing, or stand-up paddleboarding. In the evening, board a traditional Maldivian Dhoni boat for a sunset cruise. Sip mocktails/cocktails and watch dolphins jumping alongside the boat."
      },
      {
        day: 4,
        title: "Leisure Day & Beach BBQ Dinner",
        description: "Spend the day at complete leisure. Lounge on your private sun deck, swim in the infinity pool, or walk along the powdery white sands of the island. In the evening, enjoy a special candlelit seafood BBQ dinner directly on the beach."
      },
      {
        day: 5,
        title: "Check-out & Return Speedboat",
        description: "Enjoy your final breakfast over the water. Check out from the villa and take the speedboat back to Male Airport for your flight back home, fully refreshed and sun-kissed."
      }
    ]
  },
  {
    id: "bali-culture-beach",
    title: "Bali Tropical Culture & Beach Escape",
    category: "International",
    price: 59999,
    originalPrice: 69999,
    duration: "6 Days / 5 Nights",
    rating: 4.85,
    reviewsCount: 140,
    image: "https://images.unsplash.com/photo-1537996194471-e657df975ab4?auto=format&fit=crop&w=800&q=80",
    tag: "Trending",
    shortDescription: "Explore the artistic hub of Ubud, swing over rice terraces, and relax on Seminyak beach.",
    description: "Discover the Island of the Gods. This trip balances the cultural heart of Bali in Ubud—with its temples, lush forest ravines, and rice paddies—with the trendy beach vibe, surfing spots, and beautiful sunsets of Seminyak and Uluwatu.",
    highlights: [
      "Visit the iconic Tegallalang Rice Terraces and Bali Swing",
      "See the sunset cliff temple of Uluwatu with Kecak Fire Dance",
      "Day trip to Nusa Penida island (Kelingking Beach)",
      "Explore Ubud Monkey Forest and local artisan markets"
    ],
    itinerary: [
      {
        day: 1,
        title: "Arrival in Denpasar & Transfer to Ubud",
        description: "Arrive at Bali International Airport. Private transfer to Ubud, the cultural center of Bali. Check in to your villa overlooking jungle ravines. Spend the evening browsing local art galleries and cafes."
      },
      {
        day: 2,
        title: "Ubud Culture, Rice Terraces & Bali Swing",
        description: "Visit the sacred Ubud Monkey Forest, followed by the stunning Tegallalang Rice Terraces. Experience the thrilling Bali Swing high above the palms. Stop at a coffee plantation to taste the famous Luwak coffee."
      },
      {
        day: 3,
        title: "Kintamani Volcano & Temples",
        description: "Drive to Kintamani for panoramic views of the active Mount Batur volcano and its crater lake. On the return journey, visit Tirta Empul Holy Water Temple and participate in a traditional purification ritual."
      },
      {
        day: 4,
        title: "Ubud to Seminyak & Uluwatu Sunset",
        description: "Check out and drive to the coastal town of Seminyak. Check in to your beach resort. In the afternoon, visit Uluwatu Temple perched on a 70m high sea cliff. Watch the dramatic sunset and the spiritual Kecak Fire Dance performance."
      },
      {
        day: 5,
        title: "Nusa Penida Island Adventure Day Trip",
        description: "Early morning speed boat to Nusa Penida Island. Visit the famous T-Rex shaped Kelingking Beach, Broken Beach, and Angel's Billabong. Snorkel at Crystal Bay. Return to mainland Bali in the evening."
      },
      {
        day: 6,
        title: "Leisure Morning & Departure",
        description: "Enjoy a leisurely floating breakfast in your private pool. Indulge in some last-minute souvenir shopping in Seminyak before transferring to Denpasar Airport for your departure flight."
      }
    ]
  }
];
